<div class="inner_title_area">
  <div class="container">
    <div class="row">
      <div class="col-md-12 text-center">
        <h1>{{title}}</h1>
      </div>
    </div>
  </div>
</div>
